import { ErrorCodes } from '..';
import { StandardError } from '../base-error';

export class ActionFailedError extends StandardError {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(action: string, originalError: unknown) {
    super(`Action ${action} has failed with error`, ErrorCodes.INTERNAL_ERROR, { originalError });
  }
}
